import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import GetSvgIcon from "../../images/svglist";
import moment from "moment";
import {
  customDataTableStyles,
  DATE_FORMAT_MOMENT,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";
import DataTable from "react-data-table-component-with-filter";
import { CallApiPost } from "../Helper/serviceApi";

const AdvancePaymentDetails = ({
  tableData,
  advDtlColumns,
}) => {
  const [spinner, setSpinner] = useState(false);

  
  const advDownload = async (orderData) => {
    setSpinner(true);
    const response = await CallApiPost(`DownloadCN/${orderData.payment_id}`);
    setSpinner(false);
    if (response.respCode === 200) {
      window.open(response.respData, "_blank");
    }
  };

  return (
    <>
      <div className="col-md-12 customized-data-table position-relative">
        {
          <DataTable
            columns={advDtlColumns}
            data={tableData}
            pagination
            striped
            highlightOnHover
            paginationRowsPerPageOptions={defaultRowsPerPageOptions}
            paginationPerPage={defaultPageLimit}
            customStyles={customDataTableStyles}
          />
        }
      </div>
    </>
  );
};

export default AdvancePaymentDetails;
